import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { CompanyData } from 'src/common/interfaces/companies';

export interface CompanyFeaturesState {
  features: CompanyData['features'] | null;
}

const initialState: CompanyFeaturesState = {
  features: null,
};

const companyFeaturesSlice = createSlice({
  name: 'companyFeatures',
  initialState,
  reducers: {
    setCompanyFeatures: (state, action: PayloadAction<CompanyData['features'] | null>) => ({
      ...state,
      features: action.payload,
    }),
    clearCompanyFeatures: (state) => ({
      ...state,
      features: null,
    }),
  },
});

export const { setCompanyFeatures, clearCompanyFeatures } = companyFeaturesSlice.actions;

const companyFeaturesReducer = companyFeaturesSlice.reducer;

export { companyFeaturesReducer };
